// VARIABLES
export const LOAD_VARIABLES = "LOAD_VARIABLES";
export const LOAD_VARIABLES_SUCCESS = "LOAD_VARIABLES_SUCCESS";
export const LOAD_VARIABLES_FAILURE = "LOAD_VARIABLES_FAILURE";

// VARIABLES DATAS
export const LOAD_VARIABLE_DATA = "LOAD_VARIABLE_DATA";
export const LOAD_VARIABLE_DATA_SUCCESS = "LOAD_VARIABLE_DATA";
export const LOAD_VARIABLE_DATA_FAILURE = "LOAD_VARIABLE_DATA_FAILURE";

// UPDATE_MODELIZATION_DATA

export const UPDATE_MODELIZATION_DATA = "UPDATE_MODELIZATION_DATA";
export const UPDATE_VARIABLE_TO_MODEL_MODELIZATION_DATA_SUCCESS =
  "UPDATE_VARIABLE_TO_MODEL_MODELIZATION_DATA_SUCCESS";

export const UPDATE_EXPLICATIVE_VARIABLES_MODELIZATION_DATA_SUCCESS =
  "UPDATE_EXPLICATIVE_VARIABLES_MODELIZATION_DATA_SUCCESS";
export const UPDATE_MODELIZATION_RESULT_SUCCESS =
  "UPDATE_MODELIZATION_RESULT_SUCCESS";

export const UPDATE_MODELIZATION_RESULT_PROGRESS =
  "UPDATE_MODELIZATION_RESULT_PROGRESS";

export const UPDATE_MODELIZATION_DATA_FAILURE =
  "UPDATE_MODELIZATION_DATA_FAILURE";

export const UPDATE_MODELIZATION_RESULT_DATA =
  "UPDATE_MODELIZATION_RESULT_DATA";

export const UPDATE_MODELIZATION_RESULT_DATA_SUCCESS =
  "UPDATE_MODELIZATION_RESULT_DATA_SUCCESS";

export const UPDATE_MODELIZATION_RESULT_DATA_ERROR =
  "UPDATE_MODELIZATION_RESULT_DATA_ERROR";

export const INIT_EXPLICATIVE_VARIABLES_MODELIZATION_IN_STORE =
  "INIT_EXPLICATIVE_VARIABLES_MODELIZATION_IN_STORE";

export const INIT_VARIABLE_TO_MODEL_MODELIZATION_IN_STORE =
  "INIT_VARIABLE_TO_MODEL_MODELIZATION_IN_STORE";

export const INIT_MODELING_RESULT_STORE = "INIT_MODELING_RESULT_STORE";

export const INIT_SCENARIO_IN_STORE = "INIT_SCENARIO_IN_STORE";

export const INIT_PROGRESS_MODELIZATION_TREATMENT_MESSAGE =
  "INIT_PROGRESS_MODELIZATION_TREATMENT_MESSAGE";

export const DELETE_EXPLICATIVE_VARIABLE_IN_IN_Store =
  "DELETE_EXPLICATIVE_VARIABLE_IN_IN_Store";

export const LOAD_SCENARIO_BY_ID = "LOAD_SCENARIO_BY_ID";
export const LOAD_SCENARIO_BY_ID_SUCCESS = "LOAD_SCENARIO_BY_ID_SUCCESS";
export const LOAD_SCENARIO_BY_ID_FAILURE = "LOAD_SCENARIO_BY_ID_FAILURE";

export const ADD_SCENARIO = "ADD_SCENARIO";
export const ADD_SCENARIO_SUCCESS = "ADD_SCENARIO_SUCCESS";
export const ADD_SCENARIO_FAILURE = "ADD_SCENARIO_FAILURE";

export const UPDATE_SCENARIO = "UPDATE_SCENARIO";
export const UPDATE_SCENARIO_SUCCESS = "UPDATE_SCENARIO_SUCCESS";
export const UPDATE_SCENARIO_FAILURE = "UPDATE_SCENARIO_FAILURE";

export const LOAD__DATA_ANALYTICS_CONFIG = "LOAD__DATA_ANALYTICS_CONFIG";
export const LOAD__DATA_ANALYTICS_CONFIG_SUCCESS =
  "LOAD__DATA_ANALYTICS_CONFIG_SUCCESS";
export const LOAD__DATA_ANALYTICS_CONFIG_FAILURE =
  "LOAD__DATA_ANALYTICS_CONFIG_FAILURE";

export const ADD_DATA_ANALYTICS_CONFIG = "ADD_DATA_ANALYTICS_CONFIG";
export const ADD_DATA_ANALYTICS_CONFIG_SUCCESS =
  "ADD_DATA_ANALYTICS_CONFIG_SUCCESS";
export const ADD_DATA_ANALYTICS_CONFIG_FAILURE =
  "ADD_DATA_ANALYTICS_CONFIG_FAILURE";

export const UPDATE_DATA_ANALYTICS_CONFIG = "UPDATE_DATA_ANALYTICS_CONFIG";
export const UPDATE_DATA_ANALYTICS_CONFIG_SUCCESS =
  "UPDATE_DATA_ANALYTICS_CONFIG_SUCCESS";
export const UPDATE_DATA_ANALYTICS_CONFIG_FAILURE =
  "UPDATE_DATA_ANALYTICS_CONFIG_FAILURE";

export const DELETE_DATA_ANALYTICS_CONFIG = "DELETE_DATA_ANALYTICS_CONFIG";
export const DELETE_DATA_ANALYTICS_CONFIG_SUCCESS =
  "DELETE_DATA_ANALYTICS_CONFIG_SUCCESS";
export const DELETE_DATA_ANALYTICS_CONFIG_FAILURE =
  "DELETE_DATA_ANALYTICS_CONFIG_FAILURE";
